import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { PiNavigationArrow, PiPlus, PiTrash } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetArtistLightList } from 'services/artists/light';
import { IArtistMutationForm } from 'services/artists/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { object, string } from 'yup';

const artistsInBandInitialValue = {
  value: '',
  nickname: '',
};

export const artistsInBandSchema = object().shape({
  value: string().required(''),
  nickname: string(),
});

const ArtistBand = () => {
  const {
    values,
    status,
    setFieldValue,
    initialValues,
  }: IFormikContextType<IArtistMutationForm> =
    useFormikContext<IArtistMutationForm>();
  const { t } = useTranslation();

  const navigate = useNavigate();

  // const [searchNickname, setSearchNickname] = useState("");

  // const [debouncedNickname] = useDebounce(searchNickname, 1000);

  // const artists = useGetArtistListInfinite({
  //   page: 0,
  //   itemCount: 10,
  //   nickname: debouncedNickname,
  // });

  const artists = useGetArtistLightList();

  const findArtistIndex = (id: string) =>
    values.artistsInBand.findIndex(artist => artist.value === id);

  const isLatestArtistSelected = !!values.artistsInBand.length
    ? !!values.artistsInBand[values.artistsInBand.length - 1]?.value.length
    : true;

  // useEffect(() => {
  //   artists.refetch();
  // }, [debouncedNickname]);

  // const artistsSelectOptions = artists.data?.pages
  //   .flat()
  //   .filter(
  //     (globalArtist) =>
  //       !values.artistsInBand.find(
  //         (artist) => artist.value === globalArtist.id
  //       ) &&
  //       globalArtist.id !== initialValues.id &&
  //       !globalArtist.isBand
  //   )
  //   .map((artist) => ({
  //     label: artist.nickname,
  //     value: artist.id,
  //   }));

  const artistsSelectOptions =
    artists.data?.map(artist => ({
      label: artist.nickname,
      value: artist.id,
    })) ?? [];

  return (
    <Table
      id={'ArtistBand'}
      size='compact'
      data={{
        nodes: values.artistsInBand.map(artist => ({
          id: artist.value,
          nickname: artist.nickname ?? '',
        })),
      }}
      columns={[
        {
          label: t(`input.label.nickname`),
          renderCell: ({ nickname, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={`${nickname}`} />
              ) : (
                <FormInput.Select
                  name={`artistsInBand[${findArtistIndex(id)}].value`}
                  label={t(`input.label.artist`)}
                  placeholder={t('input.label.nickname')}
                  // onInputChange={value => setSearchNickname(value)}
                  onChange={value => {
                    setFieldValue(
                      `artistsInBand[${findArtistIndex(id)}].nickname`,
                      value.label
                    );
                  }}
                  value={{
                    label: nickname,
                    value: id,
                  }}
                  options={artistsSelectOptions}
                  isSearchable
                  isAsync
                  isLoading={artists.isLoading}
                />
              )}
            </TableItem>
          ),
        },
        {
          label: '',
          renderCell: ({ id }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? (
                <Button
                  isClear
                  onlyIcon
                  onClick={() => window.open(`/artist/${id}/external`, '_blank')}>
                                    <Button.Description description={t('button.open')} />

                                    <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              ) : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={() =>
                    setFieldValue(
                      'artistsInBand',
                      values.artistsInBand.filter(artist => artist.value !== id)
                    )
                  }>
                                    <Button.Description description={t('button.remove')} />

                                    <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    disable={!isLatestArtistSelected}
                    onClick={() =>
                      setFieldValue(
                        `artistsInBand[${values.artistsInBand.length}]`,
                        artistsInBandInitialValue
                      )
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
    />
  );
};

export default ArtistBand;
